export const REPORT_CURRENCY_TYPE = 'currency'
export const REPORT_DATE_TYPE = 'date'
export const REPORT_DATETIME_TYPE = 'datetime'
export const REPORT_DECIMAL_TYPE = 'decimal'
export const REPORT_INTEGER_TYPE = 'int'

export const REPORT_DATE_TYPES = [REPORT_DATE_TYPE, REPORT_DATETIME_TYPE]

export const REPORT_NUMBER_TYPES = [
  REPORT_CURRENCY_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE
]

export const REPORT_TABLE_TYPES = [
  REPORT_CURRENCY_TYPE,
  REPORT_DATE_TYPE,
  REPORT_DATETIME_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE
]
